import React from 'react';

type RetryIconProps = React.SVGProps<SVGSVGElement>;

const RetryIcon: React.FC<RetryIconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M20.0227 3.98543L20.0227 8.98572L19.4417 8.98572L15.0227 8.98572"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M19.3238 8.63827C17.7274 5.1568 13.8088 3.23086 9.98513 4.25615C5.71709 5.40062 3.1837 9.78883 4.32664 14.0575C5.46958 18.3262 9.85605 20.8588 14.1241 19.7144C15.9749 19.2181 17.4995 18.1118 18.5396 16.6699"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export default RetryIcon;
